document.addEventListener('scroll', () => {
    const scrollingSection = document.querySelector('scrolling-image-list');
    if (scrollingSection) {
        // Check if the section is in view
        const rect = scrollingSection.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            // Apply the style when the section is in view
            scrollingSection.querySelectorAll('.ara-image-right').forEach(image => {
                image.parentElement.parentElement.parentElement.parentElement.style.order = 2;
            });
        }
    }
});



$(document).ready(function(){
  $('.tab_nav li:first-child').addClass('active');
  $('.tabcontent').hide();
  $('.tabcontent:first').show();
  
  // Click function
  $('.tab_nav li').click(function(){
    $('.tab_nav li').removeClass('active');
    $(this).addClass('active');
    $('.tabcontent').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });  


  $('.product-media-slider').slick({
    slidesToShow:1,
    dots:true,
    arrows:false,
   
  });

  $('.testimonial-inner').slick({
    slidesToShow:2,
    dots:true,
    arrows:false,
     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,

        }
      }
    ]
  });

  //   $(".slider-range").on( "input", function() {
  //   var divisor = $(this).parents(".before_after_center").find(".divisor")
  //   var handle = $(this).parents(".before_after_center").find(".handle");
  //   var slider = $(this).parents(".before_after_center").find(".slider-range");
  //   handle.css("left",  slider.val()+"%");
  //   divisor.css("width",  slider.val()+"%");
  // });
  
   $('.slick-track').slick({
    slidesToShow:3,
    dots:true,
    arrows:false,
    appendDots: '.result-slick-dots',

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

    
   $('.section-result-section-duo .result_slider').slick({
    slidesToShow:3,
    dots:false,
    arrows:true,

     responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
$('.faq-question').click(function() {
  $(this).siblings().slideToggle();
  $(this).parents('.faq__item,.faq-item').toggleClass('active');
  $(this).parents('.faq__item,.faq-item').siblings().find('.faq-answer').slideUp();
  $(this).parents('.faq__item,.faq-item').siblings().removeClass('active');
});


  $('.product__accordion summary').click(function() {
  $(this).siblings().slideToggle();
  $(this).parents('.product__accordion').toggleClass('active');
  $(this).parents('.product__accordion').siblings().find('.accordion__content').slideUp();
  $(this).parents('.product__accordion').siblings().removeClass('active');
});


  var $slider = $('.pproduct-list-inner');
  var $progressBar = $('.progress__bar');
  var $progressBarLabel = $('.slider__label');

  // Set initial background size and aria-valuenow
  $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2);

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

    if (calc === 0) {
      $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2); // Set background size to 2% if next slide is the first one
    } else {
      $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
    }

    $progressBarLabel.text(calc + '% completed');
  });

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    speed: 400,
    
  
    infinite: true, // Enable infinite looping
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 741,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  
    $('.scroe_video_slider.default .score_video').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  centerMode:true,
  responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1    
      }
    }     
  ]
});  

$('.template-duo.score_video').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  centerMode:true,
  responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    }     
  ]
}); 




   function isInViewport(theDiv) {
      let elementTop = theDiv.offset().top;
      let elementBottom = elementTop + theDiv.outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + window.innerHeight;
      return elementBottom > viewportTop && elementTop < viewportBottom;
      }
      var animationDone = false;
      if ($('.pro_vid_img_sec').length) {
      $(window).on('scroll', function(){
        if (!animationDone) {
        if(isInViewport($('.pro_vid_img_sec'))) {
          animationDone = true;
          $(".circleBarProgress").each(function () {
            var t = $(this).find(".circleBar"),
                x = $(this).find(".circleBarWrapper"),
                i = $(this).find("span"),
                e = parseInt(i.text(), 10);
            $({ p: 0 }).animate(
                { p: e },
                {
                    duration: 3e3,
                    easing: "swing",
                    step: function (e) {
                        x.css({background: "conic-gradient(#e5bab9 0deg " + e + "%, #fbdbda " + e + "%)"}), i.text(0 | e);

                    },
                }
            );
          });
        }
      }
      });
      }
if ($('#stock-number').length) {
  
  function updateStockNumber() {
    let stockNumber = document.getElementById('stock-number');
    let currentNumber = parseInt(stockNumber.innerText);
    let decreaseAmount = Math.floor(Math.random() * 5) + 1; // Random decrease between 1 and 5
    let newNumber = currentNumber - decreaseAmount;

    if (newNumber > 0) {
        stockNumber.innerText = newNumber;
    } else {
        // Restart the counter from the starting value
        parseInt(stockNumber.getAttribute('data-order'));
    }
}

// Initial update after 2-3 seconds
setTimeout(updateStockNumber, Math.floor(Math.random() * 2001) + 2000); // Random time between 2000ms and 4000ms

// Random updates every 5 seconds
setInterval(() => {
    setTimeout(updateStockNumber, Math.floor(Math.random() * 3001) + 2000); // Random time between 2000ms and 5000ms
}, 5000);
}

}); 

$(document).ready(function () {
  var shippingDays = $('.shipping__date').data('shippingsday');
  function getFormattedDate(date) {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    let day = days[date.getDay()] + ', ' + date.getDate();
    let month = monthNames[date.getMonth()];

    return `${day} ${month}`;
  }

  function addDaysToDate(date, daysToAdd) {
    let newDate = new Date(date);
    newDate.setDate(date.getDate() + daysToAdd);

    return newDate;
  }

  let todaysDate = new Date();
  let nexttwodaysdate = addDaysToDate(
    todaysDate, shippingDays);
  
  $(".deliverydate").text(" " + getFormattedDate(nexttwodaysdate));
});


  $(document).ready(function(){
        $('a.shipping-modal').click(function(e){
          e.preventDefault();          
          $('.modal.shipping-modal').css('display','block');
          $('body').css('overflow-y','hidden'); //Prevent double scrollbar.
        });

        $('.close-modal,.modal-sandbox').click(function(e){
          e.preventDefault();          
          $('.modal.shipping-modal').css('display','none');
          $('body').css('overflow-y','auto'); //Prevent double scrollbar.
        });
        $('a.value-props-modal').click(function(e){
          e.preventDefault();          
          $('.modal.value-props-modal').css('display','block');
          $('body').css('overflow-y','hidden'); //Prevent double scrollbar.
        });

        $('.close-modal,.modal-sandbox').click(function(e){
          e.preventDefault();          
         $('.modal.value-props-modal').css('display','none');
          $('body').css('overflow-y','auto'); //Prevent double scrollbar.
        });

        $('a.guarantee-value-props-modal').click(function(e){
          $('.modal.guarantee-value-props-modal').css('display','block');
          $('body').css('overflow-y','hidden'); //Prevent double scrollbar.
        });

        $('.close-modal,.modal-sandbox').click(function(e){
          e.preventDefault();          
          $('.modal.guarantee-value-props-modal').css('display','none');
          $('body').css('overflow-y','auto'); //Prevent double scrollbar.
        });
        
        
      });

    $(document).ready(function(){
         var pack2Selector = $('input.block-swatch__radio[value="2 Pack"]'); 
        if (typeof pack2Selector.attr('variant-id') !== 'undefined' && typeof pack2Selector.attr('variant-id') !== false) {
          let pack2VId = pack2Selector.attr('variant-id');
            // pack2Selector.attr("checked","true");
            $('[name="id"]').val(pack2VId); 
             var var_price = pack2Selector.closest('.block-swatch').find('.var_price');
            if (typeof var_price.data('original-price') !== 'undefined' && typeof var_price.data('original-price') !== false) 
              var_price = var_price.data('original-price');
            else 
              var_price = var_price.text();
             var comvar_price = pack2Selector.closest('.block-swatch').find('.var_com_price').text(); 
             var Sdiscount = pack2Selector.closest('.block-swatch').find('.percent-discount').text(); 
              $('.price-list .price.price--highlight').text(var_price);
              $('.price-list .price.price--compare').text(comvar_price);
              $('.product-meta__label-list.label-list .label.label--highlight').text(Sdiscount);
              if ($('#StickyAddToCart .add_to_cart_price').length) {
              $('#StickyAddToCart .add_to_cart_price').text(' - '+var_price);
              $('#StickyAddToCart .product-compare-at-price').text(comvar_price);
              }
              
        }
    });
     

$('.block-swatch__radio').click(function(){
  if ($(this).val() == '2 Pack') {
    $('.swatch-product-free--addon').addClass('add-border');
  }
  else {
    $('.swatch-product-free--addon').removeClass('add-border');
  }
    
});

$(document).on("click",".klaviyo-close-form",function() {
       $('.kl-private-reset-css-Xuajs1').addClass('out');
    });


// Free Gift Product
$(document).ready(function(){

  const freeProductVariantId = $('#freeProductVariantId').attr('freeProductVariantId');
  // const mainProductId = $('#mainProductId').attr('mainProductId');
  const mainProductVariantId = $('.mainProductVariantId');

  if (freeProductVariantId) {

     var found_mainProduct_in_cart = false;
      var found_freeProduct_in_cart = false;
          $.ajax({
          type: 'GET',
          url: '/cart.json',
          dataType: 'json',
          success: function(data) {
            let items = data.items;
            let found_package_in_cart = false;
            let line_item_id = null;
            for(var i=0; i < items.length; i++){
              line_item_id = items[i].id;
              mainProductVariantId.each(function(i, obj) {
              if (line_item_id == $(this).attr('mainProductVariantId'))  
              {
                found_mainProduct_in_cart = true;
              }
              else if ( line_item_id == freeProductVariantId ) {
                found_freeProduct_in_cart = true; 
              }
              });
            }
            if(!found_mainProduct_in_cart && found_freeProduct_in_cart) {
           jQuery.post('/cart/change.json', { quantity: 0, id: freeProductVariantId })
          .done(function() {
            console.log(" Free sachet -  removed ");
            window.location.reload();
           });

         }
            else if(found_mainProduct_in_cart && !found_freeProduct_in_cart) {
          jQuery.post('/cart/add.json', { quantity: 1, id: freeProductVariantId })
          .done(function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));
          });
            }
          }
        });

        document.addEventListener('cart:updated', function(event) {
         var cart = event.detail?.cart;
         if (!cart) return;
            let items = cart.items;
            let found_mainProduct_in_cart = false;
            let found_freeProduct_in_cart = false;
            let line_item_id = null;
            for(var i=0; i < items.length; i++){
              line_item_id = items[i].id;
                mainProductVariantId.each(function(i, obj) {
              if (line_item_id == $(this).attr('mainProductVariantId'))  
              {
                found_mainProduct_in_cart = true;
              }
              else if ( line_item_id == freeProductVariantId ) {
                found_freeProduct_in_cart = true; 
              }
              });

            }
          if (found_mainProduct_in_cart == false && found_freeProduct_in_cart) {
            jQuery.post('/cart/change.json', { quantity: 0, id: freeProductVariantId })
          .done(function() {
            console.log(" Free sachet -  removed");
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));
                           })
          }
          else if (found_mainProduct_in_cart == true && !found_freeProduct_in_cart) {
          jQuery.post('/cart/add.json', { quantity: 1, id: freeProductVariantId })
          .done(function() {
            console.log(" Free sachet -  added ");
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));})
          }
        });
  
  }

  document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let varTitle = variant.title;
  console.log(varTitle);
  if (varTitle == '2 Pack') {
    $('.custom-free-product-ids').find('input').attr("disabled", false);
  }
  else {
    $('.custom-free-product-ids').find('input').attr("disabled", true);
  }
});


function isCart() {
  if (document.URL.includes("cart")) return true;
  else false;
}

  $(document).on('click', '.line-item__remove-button.main-product--true', function(e){
       e.preventDefault();
    var updates = {};
    updates[$(this).data('line-id')] = 0;
    updates[freeProductVariantId] = 0;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      if (isCart()) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
       }));
      setTimeout(function() { 
        location.reload();
    }, 100);
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
             }));
      return response.json();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    
      });




    $('.block-swatch__radio').change(function() {
   var var_price = $(this).parents('.block-swatch').find('.var_price').text();
   var comvar_price = $(this).parents('.block-swatch').find('.var_com_price').text(); 
    $('#StickyAddToCart .add_to_cart_price').text(var_price);
    $('#StickyAddToCart .product-compare-at-price').text(comvar_price);
  });


  
// marquee-slider
    $('.marquee-poster-slider').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    buttons: false
  });

    
// marquee-slider-section
    $('.marquee-slider-inner').slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 8,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    buttons: false,
    responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1    
      }
    }     
  ]
  });

});

     // load star rating badges on the cart page 
      $(document).ready(function(){
          $(document).on('click', '.header__secondary-links a.header__icon-wrapper.tap-area, #AddToCart, .product-item__cta-wrapper button[type="submit"]', () => {
            setTimeout(function () {
              StampedFn.loadBadges();
            }, 2000);
          });
      });



